import { audioType } from '../../../texas/interfaces'
import { useEffect, useState } from 'react'
import { useGameBoardSounds } from './gameBoardSounds'

export const handleCardSoundsSFX = (
  audio: audioType,
  dealOut: boolean,
  state: number,
  player: string[],
  dealer: string[],
  showLoader: boolean,
  startDeal: boolean,
  isLose: boolean,
) => {
  const sfxs = useGameBoardSounds(audio?.volume)
  const [dealedCards, setdealedCards] = useState<number>(0)

  useEffect(() => {
    !showLoader && startDeal && audio?.sound && sfxs.playcardDealSFX()

    dealOut && audio?.sound && player[0] !== 'X0' && sfxs.playcardClearSFX()
  }, [dealedCards])

  useEffect(() => {
    if (startDeal && !dealOut) {
      if (state === 4) {
        timerFunc(4)
      }
      if (state === 14) {
        timerFunc(3)

      }
      if (state === 5 || isLose || state === 11 || state === 15) {
        audio?.sound && sfxs.playcardDealSFX()
      }
    }
    if (dealOut) {
      dealer[0] === 'X0' ? timerFunc(2, 150) : timerFunc(3, 150)
    }
  }, [dealOut, startDeal, state])

  const timerFunc = (counter: number, delay?: number) => {
    const intervalTime = delay ? delay : 310
    const cardsSum = counter
    let x = 0
    const soundInterval = setInterval(() => {
      x++
      setdealedCards(x)
      if (x >= cardsSum) {
        clearInterval(soundInterval)
        return
      }
    }, intervalTime)
  }
}
